module.exports = __webpack_public_path__ + "img/direct.5b53a1d4.svg";